// routes
import useReactRouter from "use-react-router";
import { useStoreState } from "app/store";

export interface IHookProps extends ReturnType<typeof useProps> {}

export default function useProps() {
  const states = useStoreState(state => ({
    currentUser: state.app.currentUser,
    signIn: state.signIn,
  }));

  const router = useReactRouter<Vingle.IMatchParams>();
  return {
    ...states,
    ...router,
  };
}
